







import Vue, { PropType } from 'vue';
import { IBusinessDetails } from '@/Store/index';
import BaseBusinessOverviewDetails from './BaseBusinessOverviewDetails.vue';
import BusinessOverviewDeals from './BusinessOverviewDeals.vue';

export default Vue.extend({
  name: 'BusinessOverview',
  props: {
    details: {
      type: Object as PropType<IBusinessDetails>,
      required: true,
    },
  },
  components: {
    BaseBusinessOverviewDetails,
    BusinessOverviewDeals,
  },
});
